import * as React from 'react';
import { Search } from 'lucide-react';

import { cn } from '@shared/lib/utils';

import { Input } from '../primitives/input';

export interface SearchInputProps extends Omit<React.ComponentProps<'input'>, 'type'> {
  inputClassName?: string;
  iconClassName?: string;
}

const SearchInput = React.forwardRef<HTMLInputElement, SearchInputProps>(
  ({ className, inputClassName, iconClassName, ...props }, ref) => {
    return (
      <div className={cn('relative w-full', className)}>
        <Search
          aria-hidden="true"
          className={cn(
            'pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground',
            iconClassName
          )}
        />
        <Input
          ref={ref}
          type="search"
          className={cn(
            'pl-10 [&::-webkit-search-cancel-button]:appearance-none [&::-webkit-search-decoration]:appearance-none',
            inputClassName
          )}
          {...props}
        />
      </div>
    );
  }
);
SearchInput.displayName = 'SearchInput';

export { SearchInput };
